import { Environment } from '@util/Environment';
import 'firebase/compat/remote-config';
import { App } from 'hydra-data-types';
import { MarkViewedOn } from './Experiment';
import { RemoteConfigExperiment } from './RemoteConfigExperiment';

namespace Variant {
  export const Dev = {
    A: 'VariantA',
    B: 'VariantB',
  } as const;

  export const PaymentSoftTrial = {
    Control: 'Control',
    Combo: 'Combo',
  } as const;
}

/**
 * Configure the active experiments. This should be done in conjunction with configuring the related experiments in
 * Firebase RemoteConfig. See the Dev experiment for an example of naming conventions etc.
 *
 * This Notion page has more detailed information:
 * https://www.notion.so/mindsethealth/Setting-up-Split-Test-Experiments-0102de5390c04668bee6d4111ee86516
 */
export const AllExperiments = {
  Dev: new RemoteConfigExperiment({
    name: 'DevExperiment',
    variants: Variant.Dev,
    default: Variant.Dev.A,
    activeApps: [App.Nerva],
    markViewedOn: Environment.DEVELOPMENT ? MarkViewedOn.Init : MarkViewedOn.None,
  }),

  /**
   * Payment page: current layout (Control) vs Combo, which makes the trial theirs first (their name
   * and condition, the doctor, what's included, the guarantee) above Control's price and
   * checkout. Only people with a free trial see Combo.
   */
  PaymentSoftTrial: new RemoteConfigExperiment({
    name: 'PaymentSoftTrial',
    variants: Variant.PaymentSoftTrial,
    default: Variant.PaymentSoftTrial.Control,
    // Draft: off in production, so live users get Control and send no events or traits for it.
    // Add Nerva for production when launching it in Remote Config.
    activeApps: Environment.PRODUCTION ? [] : [App.Nerva],
    markViewedOn: MarkViewedOn.React,
  }),
} as const;

export const ActiveExperimentList = Object.values(AllExperiments).filter(
  (experiment) => experiment.isActive
);
